<template>
<v-list-tile @click='$emit("selected", value)' >
  <v-list-tile-content>
    <v-list-tile-title>
      <span v-if='value && withId' >#{{value.id}}</span></span> {{titleText}}
    </v-list-tile-title>
    <slot name='sub-title' >
      <v-list-tile-sub-title v-if='subTitleText' >
        {{subTitleText}}
      </v-list-tile-sub-title>
    </slot>
  </v-list-tile-content>
  <slot name='action' ></slot>
</v-list-tile>
</template>
<script>
export default {
  name: 'GenericListItem',
  props: {
    value: { type: Object, required: true },
    itemTitle: { type: String, required: false },
    itemSubTitle: { type: String, required: false },
    title: { type: String, required: false },
    withId: { type: Boolean, default: false }
  },
  computed: {
    titleText () {
      if (this.title) { return this.title }
      if (typeof this.value === 'string') { return this.value }
      if (this.itemTitle) { return this.getObjectPath(this.value, this.itemTitle) }
      return this.value.title || this.value.name || this.value.id || this.value
    },
    subTitleText () {
      if (this.itemSubTitle) { return this.getObjectPath(this.value, this.itemSubTitle) }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// GenericListItem.vue?0180ff7a